import type { View } from "../../common/types.ts";
import { helpers } from "../util/helpers.ts";

type History = Exclude<View<"history">, { invalidSeason: true }>;

export const ChampionshipRoster = ({ roster, champ, season }: {
	roster: History["champRoster"];
	champ: History["champ"];
	season: number;
}) => {
	if (!roster || !champ || roster.starters.length + roster.bench.length === 0) return null;
	return <section className="mt-4">
		<h2><a href={helpers.leagueUrl(["roster", `${champ.seasonAttrs.abbrev}_${champ.tid}`, season])}>{champ.seasonAttrs.region} {champ.seasonAttrs.name}</a> Championship Roster</h2>
		<p className="text-body-secondary">Regular season statistics with the championship team. Starters ranked by games started.</p>
		{(["starters", "bench"] as const).map((group) => <div key={group}>
			<h3>{group === "starters" ? "Starters" : "Bench"}</h3>
			<ul className="list-unstyled">{roster[group].map((p) => <li key={p.pid} className="mb-2">
				{p.ratings.pos} <a href={helpers.leagueUrl(["player", p.pid])}>{p.name}</a>{" "}
				({(["pts", "trb", "ast", "stl", "blk"] as const).map((stat) => `${helpers.roundStat(p.stats[stat], stat)} ${stat === "trb" ? "reb" : stat}`).join(", ")},{" "}
				{(["fgp", "tpp", "ftp"] as const).map((stat) => helpers.roundStat(p.stats[stat], stat)).join("/") }%)
			</li>)}</ul>
		</div>)}
	</section>;
};
